import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var aromaticNoteSchema = {
    value: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Стойност на български *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидна стойност',
    }),
    en_value: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Стойност на английски*',
        value: '',
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидна стойност',
    }),
    note_type: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control category-dropdown',
            placeholder: '',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Тип ароматна нотка*',
        validation: {
            required: true,
        },
        value: '',
        valid: false,
        touched: false,
        hidden: true,
    }),
};
export default aromaticNoteSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/aromaticNoteSchema.ts
// module id = 318
// module chunks = 0